import { z } from 'zod';
export const signupSchema = z.object({
  orgName: z.string().min(1, 'Merchant name is required'),
  ownerEmail: z.string().email('A valid email is required'),
  gstin: z.string().optional(),
});
export type SignupInput = z.infer<typeof signupSchema>;
